import React from 'react';
import { useAddToCart, useCart } from '@src/hooks/cart';
import { useIsMainSubscribed } from '@src/hooks/user';
import { navigate } from '@reach/router';
import * as styles from './DocumentMenu.module.css';
import { slugify } from '@src/utils/slugify';
import { trackDocumentClick } from '@src/utils/trackDocumentClick';

const DocumentMenu = ({ document, onClose }) => {
  const { addToCart } = useAddToCart();
  const { ownedProducts, miniCart } = useCart();
  const isSubscribed = useIsMainSubscribed();

  const isOwned = ownedProducts.has(document.originalId);
  const isInMiniCart = miniCart.has(document.originalId);

  const { module, documentCategory, name } = document;

  const handlePreview = () => {
    const detailsPageUrl =
      name &&
      `/modules/${module?.slug}/${documentCategory
        ?.map((c) => c.slug)
        .join('/')}/${encodeURIComponent(slugify(name))}`;

    trackDocumentClick(document, {
      source: 'table_menu',
      outcome: 'detail',
      isSubscribed,
      destinationUrl: detailsPageUrl,
    });

    if (detailsPageUrl) {
      window.location.href = detailsPageUrl;
    }

    onClose();
  };

  const handleSubscribe = () => {
    trackDocumentClick(document, {
      source: 'table_menu',
      outcome: 'subscribe',
      isSubscribed,
      destinationUrl: '/subscriptions',
    });
    navigate('/subscriptions');
    onClose();
  };

  const handleAddToCart = () => {
    if (isInMiniCart) {
      navigate('/cart');
    } else {
      addToCart(document.originalId);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    onClose();
  };

  const handlePurchased = () => {
    navigate('/profile');
    onClose();
  };

  return (
    <div className={styles.menu}>
      {!document.skipPageGeneration && (
        <button onClick={handlePreview} className={styles.menuItem}>
          <svg className={styles.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
            />
          </svg>
          Preview
        </button>
      )}

      {document.isSubscription && !isSubscribed && (
        <button onClick={handleSubscribe} className={styles.menuItem}>
          <svg className={styles.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
          Subscribe
        </button>
      )}

      {!isSubscribed && (
        <>
          {isOwned ? (
            <button onClick={handlePurchased} className={`${styles.menuItem} ${styles.purchased}`}>
              <svg className={styles.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              Purchased
            </button>
          ) : (
            <button onClick={handleAddToCart} className={styles.menuItem}>
              <svg className={styles.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                />
              </svg>
              {isInMiniCart ? 'View Cart' : 'Add to Basket'}
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default DocumentMenu;
